




import { Component, mixins } from '@niknevis/vue-modules'
import TesTr from '@/modules/common/tes-table/components/shared/TesTr.vue'
import TesTableRow from '@/modules/common/tes-table/mixins/TesTableRow.vue'
import AdminUserInfoButton from '@/modules/user/components/admin/AdminUserInfoButton.vue'
import RenderProps from '@/modules/shared/components/shared/utils/RenderProps.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminUserTableActions from '@/modules/user/components/admin/table/AdminUserTableActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'

@Component({
  components: {
    TesTr
  }
})
export default class AdminUserTableRow extends mixins(TesTableRow) {
  columnComponents = {
    info: {
      component: AdminUserInfoButton,
      handler: value => ({ basicUser: value, asText: true })
    },
    phone: {
      component: RenderProps,
      handler: value => ({
        render(h, props) {
          return h('a', { attrs: { href: `tel:${value}` } }, value)
        }
      })
    },
    roles: {
      component: TextEllipsis,
      handler: value => ({ text: value })
    },
    created_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    last_login_at: {
      component: DateTooltipped,
      handler: value => ({ isoDate: value })
    },
    actions: {
      component: AdminUserTableActions,
      handler: (value, row) => ({ userId: row.id })
    }
  }
}
